import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import "./index.scss";

import {
  AuthenticationResult,
  Configuration,
  PublicClientApplication,
} from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./authConfig";
const msalInstance = new PublicClientApplication(msalConfig as Configuration);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App pca={msalInstance} />);

export const acquireAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();
  const request = {
    ...loginRequest,
    account: activeAccount || accounts[0],
  };
  try {
    const authResult: AuthenticationResult =
      await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken;
  } catch (err) {
    msalInstance.loginRedirect();
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
